import { Component, OnInit } from '@angular/core';
import { FcmService } from './services/fcm/fcm.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private fcmService: FcmService) {}

  ngOnInit(): void {
    this.fcmService.initPushNotification();
  }
}
